<template>
    <div id="latest-logs-component" class="mt-0 pt-0">

        <v-card>

            <v-card-title>
                <div class="card-title-text">
                    <span class="body-2 font-weight-bold">Az elmúlt egy hónapban történt</span><br>
                    <span class="display-1 font-weight-thin">Be- és Kihúzások</span>
                </div>

                <div class="flex-grow-1"></div>
                <v-text-field
                        name="search"
                        v-model="search"
                        label="Keresés"
                        append-icon="search"
                        outlined
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="latestLogs"
                    :loading="loading"
                    :items-per-page="23"
                    :search="search"
                    loading-text="Betöltés..."
            >
                <template class="status-text" v-slot:item.log_type="{ item }">
                    <v-chip text-color="#efefef" :color="item.log_type === 1 ? '#27ae60' : '#c0392b' ">
                        <v-icon class="status-icon">{{ item.log_type === 1 ? 'mdi-checkbox-marked-circle' : 'mdi-close-circle' }}</v-icon> {{ logTypeToText(item.log_type) }}
                    </v-chip>
                </template>

                <template v-slot:item.timestamp="{ item }">
                    {{ formatDate(item.timestamp) }}
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import Pusher from 'pusher-js'
    export default {
        name: "LatestLogs",

        data() {
            return {
                latestLogs: [],
                loading: true,
                search: '',
                headers: [
                    {
                        text: 'Név',
                        align: 'left',
                        sortable: false,
                        value: 'user.name'
                    },
                    {
                        text: 'Esemény',
                        align: 'left',
                        sortable: false,
                        value: 'log_type'
                    },
                    {
                        text: 'Időpont',
                        align: 'left',
                        sortable: false,
                        value: 'timestamp'
                    }
                ]
            }
        },

        mounted() {
            this.getLatestLogs()
            this.subscribeChannel()
        },

        methods: {
            async getLatestLogs() {
                 await this.$axios({ url: '/checkon-last-logs', method: 'GET' })
                    .then(resp => {
                        this.latestLogs = resp.data.data
                        this.loading = false
                    })
            },

            async getUserObj(id_user) {
                await this.$axios({ url: `/user-data/${id_user}`, method: 'GET' })
                    .then(resp => {
                        return resp.data.data
                    })
            },

            async subscribeChannel() {
                let pusher = new Pusher('a66417eeea6d919eb1d3', { cluster: 'eu' })
                pusher.subscribe('employee-channel')
                pusher.bind('employee-channel', data => {
                    this.loading = true
                    let dataResp = data.message

                    this.$axios({ url: `/user-data/${data.message.user}`, method: 'GET' })
                        .then(resp => {
                            let newLog = { id_user: dataResp.user, log_type: dataResp.log_type, timestamp: dataResp.time, user: resp.data.data }
                            this.latestLogs = [newLog].concat(this.latestLogs)
                            this.loading = false
                        })

                })
            },

            logTypeToText($type) {
                if($type === 1) {
                    return 'BE - Munka kezdése'
                }
                return 'KI - Munka befejezése'
            },

            formatDate(dateTime) {
                let days = ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat']
                let dateTimeParts = dateTime.split(/[- :]/)
                dateTimeParts[1]--
                const dateTimeFinal = new Date(...dateTimeParts)

                let locale = "hu-hu",
                    month = dateTimeFinal.toLocaleString(locale, { month: "long" })
                month = month.charAt(0).toUpperCase() + month.slice(1)

                let hours = dateTimeFinal.getHours() < 10 ? '0' + dateTimeFinal.getHours() : dateTimeFinal.getHours()
                let minitues = dateTimeFinal.getMinutes() < 10 ? '0' + dateTimeFinal.getMinutes() : dateTimeFinal.getMinutes()
                let seconds = dateTimeFinal.getSeconds() < 10 ? '0' + dateTimeFinal.getSeconds() : dateTimeFinal.getSeconds()

                return `${days[dateTimeFinal.getDay()]} ${hours}:${minitues}:${seconds} - ${dateTimeFinal.getFullYear()}. ${month} ${dateTimeFinal.getDate()}.`
            }
        }

    }
</script>

<style lang="scss">
    #latest-logs-component {
        .card-title-text { margin-top: -30px; }
        .status-icon { margin-right: 5px; }
    }
</style>
